<template>
  <nav class="menu-contenido" aria-label="Menú principal">
    <div class="menu-superior">
      <div class="usuario-card" v-if="store.usuarioActual">
        <div class="usuario-avatar" aria-hidden="true">{{ iniciales }}</div>
        <div class="usuario-info">
          <span class="usuario-nombre">{{ store.usuarioActual.name }}</span>
          <span class="usuario-rol">{{ rolPrincipal }}</span>
        </div>
      </div>

      <hr class="divider" />

      <div class="menu">
        <span v-if="store.tienePermiso('dashboard.ver')" class="opciones">
          <router-link
            :to="{ name: 'Dashboard' }"
            :class="{ 'active-link': route.name === 'Dashboard' }"
            :aria-current="route.name === 'Dashboard' ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg>
            <span>Dashboard</span>
          </router-link>
        </span>
        <span v-if="store.tienePermiso('calendario.ver')" class="opciones">
          <router-link
            :to="{ name: 'Calendario' }"
            :class="{ 'active-link': route.name === 'Calendario' }"
            :aria-current="route.name === 'Calendario' ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <span>Calendario</span>
          </router-link>
        </span>

        <p v-if="seccionGestion" class="seccion-titulo">Gestión</p>
        <span v-if="store.tienePermiso('modelos.ver')" class="opciones">
          <router-link
            :to="{ name: 'ListaVersiones' }"
            :class="{ 'active-link': isActive('gestion-modelo') }"
            :aria-current="isActive('gestion-modelo') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>
            <span>Gestión de Modelo</span>
          </router-link>
        </span>
        <span v-if="store.tienePermiso('indicadores.ver')" class="opciones">
          <router-link
            :to="{ name: 'ListaVersiones', query: { modo: 'indicadores' } }"
            :class="{ 'active-link': isActive('gestion-indicadores') }"
            :aria-current="isActive('gestion-indicadores') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>
            <span>Gestión de Indicadores</span>
          </router-link>
        </span>
        <span v-if="store.tienePermiso('procesos.ver')" class="opciones">
          <router-link
            :to="store.tienePermiso('procesos.crear') ? { name: 'ProcesoAutoevaluacion' } : { name: 'ProcesoAutoevaluacionUsuario' }"
            :class="{ 'active-link': isActive('proceso-autoevaluacion') }"
            :aria-current="isActive('proceso-autoevaluacion') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
            <span>Proceso de Autoevaluación</span>
          </router-link>
        </span>
<p v-if="seccionEvaluacion" class="seccion-titulo">Evaluación</p>
        <span v-if="store.tienePermiso('rubricas.ver')" class="opciones">
          <router-link
            :to="{ name: 'GestionRubricas' }"
            :class="{ 'active-link': isActive('gestion-rubricas') }"
            :aria-current="isActive('gestion-rubricas') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12h6"/><path d="M9 16h6"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"/></svg>
            <span>Gestión de Rúbricas</span>
          </router-link>
        </span>
        <span v-if="store.tienePermiso('expertos.ver')" class="opciones">
          <router-link
            :to="{ name: 'ListaVersiones', query: { modo: 'evaluacion-expertos' } }"
            :class="{ 'active-link': isActive('evaluacion-expertos') }"
            :aria-current="isActive('evaluacion-expertos') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m9 11 3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
            <span>Evaluación por Expertos</span>
          </router-link>
        </span>

        <p v-if="store.tienePermiso('campus.ver')" class="seccion-titulo">Organización</p>
        <span v-if="store.tienePermiso('campus.ver')" class="opciones">
          <router-link
            :to="{ name: 'GestionAreas' }"
            :class="{ 'active-link': isActive('gestion-areas') }"
            :aria-current="isActive('gestion-areas') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><path d="M9 9v.01"/><path d="M9 12v.01"/><path d="M9 15v.01"/><path d="M9 18v.01"/></svg>
            <span>Estructura Organizacional</span>
          </router-link>
        </span>
        <span v-if="store.tienePermiso('campus.ver')" class="opciones">
          <router-link
            :to="{ name: 'TableroProgramas' }"
            :class="{ 'active-link': isActive('tablero-programas') }"
            :aria-current="isActive('tablero-programas') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg>
            <span>Tablero de Programas</span>
          </router-link>
        </span>

        <p v-if="store.tienePermiso('usuarios.ver') || store.tienePermiso('usuarios.crear')" class="seccion-titulo">Administración</p>
        <span v-if="store.tienePermiso('usuarios.ver') || store.tienePermiso('usuarios.crear')" class="opciones">
          <router-link
            :to="{ name: 'AsignarRoles' }"
            :class="{ 'active-link': isActive('gestion-usuarios') }"
            :aria-current="isActive('gestion-usuarios') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span>Gestión de Usuarios</span>
          </router-link>
        </span>

        <span v-if="store.tienePermiso('trazabilidad.ver')" class="opciones">
          <router-link
            :to="{ name: 'Trazabilidad' }"
            :class="{ 'active-link': isActive('trazabilidad') }"
            :aria-current="isActive('trazabilidad') ? 'page' : undefined"
          >
            <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 8v4l3 3"/><path d="M3.05 11a9 9 0 1 1 .5 4"/><path d="M3 4v4h4"/></svg>
            <span>Trazabilidad</span>
          </router-link>
        </span>
      </div>
    </div>

    <div class="salir">
      <a href="#" @click.prevent="Logout">
        <svg class="icono" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
        <span>Salir</span>
      </a>
    </div>
  </nav>
</template>

<script lang="ts" setup>
/**
 * Menú lateral de navegación.
 *
 * Filtra sus ítems por los permisos del usuario. Es filtrado de PRESENTACIÓN: no
 * autoriza nada, solo evita ofrecer pantallas que devolverían 403.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router'
import useAutenticar from '@/store/IngresoAutenticar'

const route = useRoute()
const store = useAutenticar()

const iniciales = computed(() => {
  const nombre = store.usuarioActual?.name ?? ''
  return nombre
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(p => p[0].toUpperCase())
    .join('')
})

const rolPrincipal = computed(() =>
  store.usuarioActual?.roles?.[0]?.label ?? store.usuarioActual?.roles?.[0]?.name ?? 'Sin rol'
)

const seccionGestion = computed(() =>
  store.tienePermiso('modelos.ver') ||
  store.tienePermiso('indicadores.ver') ||
  store.tienePermiso('procesos.ver') ||
  store.tienePermiso('evidencias.subir')
)

const seccionEvaluacion = computed(() =>
  store.tienePermiso('rubricas.ver') ||
  store.tienePermiso('calificacion.calificar') ||
  store.tienePermiso('expertos.ver')
)

function isActive(menu: string) {
  if (route.meta.menu) {
    return route.meta.menu === menu
  }

  if (menu === 'gestion-modelo' && !route.query.modo) return true
  if (menu === 'gestion-indicadores' && route.query.modo === 'indicadores') return true
  if (menu === 'gestion-instrumentos' && route.query.modo === 'calificar instrumento') return true
  if (menu === 'gestion-rubricas' && route.meta.menu === 'gestion-rubricas') return true
  if (menu === 'asignar-evaluadores' && (route.meta.menu === 'asignar-evaluadores' || route.query.modo === 'asignar-evaluadores')) return true
  if (menu === 'evaluacion-expertos' && (route.meta.menu === 'evaluacion-expertos' || route.query.modo === 'evaluacion-expertos')) return true
  if (menu === 'gestion-evidencias' && route.meta.menu === 'gestion-evidencias') return true
  if (menu === 'proceso-autoevaluacion' && route.meta.menu === 'proceso-autoevaluacion') return true
  if (menu === 'gestion-areas' && route.meta.menu === 'gestion-areas') return true
  if (menu === 'gestion-usuarios' && route.meta.menu === 'gestion-usuarios') return true

  return false
}

const Logout = async () => {
  await store.Logout()
  router.push({ name: 'Ingreso' })
}
</script>

<style scoped>
.menu-contenido {
  width: 260px;
  background-color: #0e69a0;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.75rem 1rem 1.5rem;
  min-height: 100%;
  height: auto;
  box-sizing: border-box;
  font-family: var(--font-family);
  line-height: var(--line-height-normal);
}

.menu-superior {
  display: flex;
  flex-direction: column;
}


.usuario-card {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-md, 8px);
  padding: 0.6rem 0.75rem;
  margin-top: 0;
}

.usuario-avatar {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.25);
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.02em;
}

.usuario-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.usuario-nombre {
  font-size: 0.82rem;
  font-weight: 600;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.usuario-rol {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.65);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.divider {
  width: 100%;
  border: none;
  height: 1px;
  background-color: white;
  margin-bottom: 1.25rem;
  opacity: 0.18;
}

.menu {
  display: flex;
  flex-direction: column;
}

.seccion-titulo {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.55);
  margin: 1rem 0.75rem 0.4rem;
}

.seccion-titulo:first-of-type {
  margin-top: 0;
}

.opciones a {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  min-height: 44px;
  margin-bottom: 0.2rem;
  color: rgba(255, 255, 255, 0.92);
  font-weight: 500;
  text-decoration: none;
  padding: 0.65rem 0.75rem;
  border-radius: var(--radius-md, 8px);
  transition: background-color 180ms ease, color 180ms ease;
  box-sizing: border-box;
  font-size: 0.9rem;
  position: relative;
}

.icono {
  width: 19px;
  height: 19px;
  flex-shrink: 0;
  opacity: 0.85;
  transition: opacity 180ms ease;
}

.opciones a:hover {
  background-color: rgba(255, 255, 255, 0.12);
  color: white;
  cursor: pointer;
}

.opciones a:hover .icono {
  opacity: 1;
}

.opciones a:focus-visible {
  outline: 2px solid white;
  outline-offset: -2px;
}

.opciones a.active-link {
  background-color: white;
  color: #0e69a0;
  font-weight: 700;
  box-shadow: inset 3px 0 0 0 var(--color-secundario, #0e69a0);
}

.opciones a.active-link .icono {
  opacity: 1;
}

.salir {
  margin-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  padding-top: 1rem;
}

.salir a {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-height: 44px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 600;
  text-decoration: none;
  padding: 0.65rem 0.75rem;
  border-radius: var(--radius-md, 8px);
  transition: background-color 180ms ease, color 180ms ease;
}

.salir a:hover {
  background-color: rgba(255, 255, 255, 0.12);
  color: white;
  cursor: pointer;
}

.salir a:focus-visible {
  outline: 2px solid white;
  outline-offset: -2px;
}

@media (prefers-reduced-motion: reduce) {
  .opciones a,
  .salir a,
  .icono {
    transition: none;
  }
}

@media (max-width: 1024px) {
  .menu-contenido {
    width: 220px;
    padding: 0.6rem 0.75rem 1.25rem;
  }

.opciones a,
  .salir a {
    font-size: 0.85rem;
    padding: 0.55rem 0.6rem;
  }

  .icono {
    width: 17px;
    height: 17px;
  }
}
</style>